<template>
  <div class="container mt-4">
    <h1 class="mb-4">{{ isEdit ? 'Editar Usuario Medicinal' : 'Crear Usuario Medicinal' }}</h1>
    <form @submit.prevent="submitForm">
      <div class="form-group mb-3">
        <label for="nombre">Nombre:</label>
        <input type="text" id="nombre" v-model="usuarioLocal.nombre" class="form-control" required />
      </div>
      <div class="form-group mb-3">
        <label for="apellido">Apellido:</label>
        <input type="text" id="apellido" v-model="usuarioLocal.apellido" class="form-control" required />
      </div>
      <div class="form-group mb-3">
        <label for="identificacion">Identificación:</label>
        <input type="text" id="identificacion" v-model="usuarioLocal.identificacion" class="form-control" required />
      </div>
      <div class="form-group mb-3">
        <label for="fecha_nacimiento">Fecha de Nacimiento:</label>
        <input type="date" id="fecha_nacimiento" v-model="usuarioLocal.fecha_nacimiento" class="form-control" required />
      </div>
      <div class="form-group mb-3">
        <label for="direccion">Dirección:</label>
        <input type="text" id="direccion" v-model="usuarioLocal.direccion" class="form-control" required />
      </div>
      <div class="form-group mb-3">
        <label for="telefono">Teléfono:</label>
        <p class="text-muted">Escriba el teléfono sin 0 ni 15</p>
        <input type="text" id="telefono" v-model="usuarioLocal.telefono" class="form-control" />
      </div>
      <div class="form-group mb-3">
        <label for="email">Email:</label>
        <input type="email" id="email" v-model="usuarioLocal.email" class="form-control" />
      </div>
      <div class="form-group mb-3">
        <label for="receta_medica">Receta Médica:</label>
        <input type="text" id="receta_medica" v-model="usuarioLocal.receta_medica" class="form-control" />
      </div>
      <div class="form-group mb-3">
        <label for="estado">Estado:</label>
        <select id="estado" v-model="usuarioLocal.estado" class="form-select">
          <option value="activo">Activo</option>
          <option value="suspendido">Suspendido</option>
        </select>
      </div>
      <button type="submit" class="btn btn-primary">{{ isEdit ? 'Actualizar' : 'Crear' }}</button>
      <button type="button" class="btn btn-secondary" @click="$emit('cancelar')">Cancelar</button>
    </form>
  </div>
</template>

<script>
import { ref } from 'vue';
import axios from '@/axios';
import { useStore } from 'vuex';

export default {
  props: {
    usuarioId: Number,
    usuario: Object
  },
  setup(props, { emit }) {
    const usuarioLocal = ref({ ...props.usuario });
    const isEdit = ref(false);
    const store = useStore();
    const club_id = store.getters.getClubActual.id;

    const fetchUsuario = async () => {
      if (props.usuarioId) {
        isEdit.value = true;
        try {
          const response = await axios.get(`/api/usuario-medicinal/${props.usuarioId}`);
          const usuarioData = response.data;
          // Convertir la fecha de nacimiento al formato yyyy-MM-dd
          if (usuarioData.fecha_nacimiento) {
            usuarioData.fecha_nacimiento = new Date(usuarioData.fecha_nacimiento).toISOString().split('T')[0];
          }
          Object.assign(usuarioLocal.value, usuarioData);
        } catch (error) {
          console.error('Error al obtener usuario medicinal:', error);
        }
      }
    };

    const submitForm = async () => {
      try {
        if (isEdit.value) {
          await axios.put(`/api/usuario-medicinal/${props.usuarioId}`, { ...usuarioLocal.value, club_id });
          alert('Usuario actualizado correctamente');
          emit('usuarioActualizado');
        } else {
          await axios.post('/api/usuario-medicinal', { ...usuarioLocal.value, club_id });
          alert('Usuario creado correctamente');
          emit('usuarioCreado');
        }
      } catch (error) {
        if (error.response && error.response.data && error.response.data.error) {
          alert(error.response.data.error);
        } else {
          alert('Error al guardar usuario medicinal');
        }
        console.error('Error al guardar usuario medicinal:', error);
      }
    };

    fetchUsuario();

    return {
      usuarioLocal,
      isEdit,
      submitForm
    };
  }
};
</script>

<style scoped>
/* Estilos adicionales para el componente */
.container {
  max-width: 600px;
}
</style> 